import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b265848"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "field-group md:flex-row flex-column" }
const _hoisted_3 = { class: "field-group md:flex-row flex-column" }
const _hoisted_4 = { class: "field-group md:flex-row flex-column" }

import {
  reactive,
  ref,
  onMounted,
  PropType,
  watch,
  computed
} from 'vue';
import { FormValidator } from '@/validators/FormValidator';
import CustomTextField from '@/components/forms/fields/CustomTextField.vue';
import CustomDropdownField from '@/components/forms/fields/CustomDropdownField.vue';
import { DeviceSerializer, Device, DeviceType } from '@/enums/DeviceType';
import { Doctor } from '@/interfaces/Doctor';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorInfo',
  props: {
  modelValue: {
    type: Object as PropType<Doctor>,
    default: () => ({})
  }
},
  emits: ['update:formValidationChangeState'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const thisDoctor = ref<Doctor>(props.modelValue || ({} as Doctor));
const deviceTypes = ref<DeviceType[]>([]);
const chosenDeviceType = ref<DeviceType | undefined>();

const isInvalid = reactive({
  firstName: false,
  lastName: false,
  email: false,
  phoneNo: false,
  title: false,
  specialization: false
});

const onFieldChangeValidation = ({
  fieldName,
  isValid
}: {
  fieldName: string;
  isValid: boolean;
}) => {
  isInvalid[fieldName] = !isValid;
};

const onChosenDeviceTypeChange = (newValue) => {
  thisDoctor.value.deviceType = newValue.name;
};

const isValidForm = computed(() => {
  // Verifică dacă toate valorile din obiectul isInvalid sunt false
  return Object.values(isInvalid).every((value) => value === false);
});

onMounted(() => {
  deviceTypes.value = Object.values(Device).map(
    (device) => DeviceSerializer.deserialize(device)!
  );
});

watch(isValidForm, (newValue) => {
  emit('update:formValidationChangeState', newValue);
});

watch(
  () => props.modelValue,
  (newValue) => {
    thisDoctor.value = newValue;
    chosenDeviceType.value = DeviceSerializer.deserialize(
      thisDoctor.value.deviceType || 'ANDROID'
    );
  }
);

setTimeout(() => {
  emit('update:formValidationChangeState', isValidForm);
}, 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomTextField, {
        id: "firstName",
        modelValue: thisDoctor.value.firstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisDoctor.value.firstName) = $event)),
        placeholder: "Nume",
        iconClass: "pi pi-user",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest camp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "lastName",
        modelValue: thisDoctor.value.lastName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((thisDoctor.value.lastName) = $event)),
        placeholder: "Prenume",
        iconClass: "pi pi-user",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest camp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CustomTextField, {
        id: "phoneNo",
        modelValue: thisDoctor.value.phoneNo,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((thisDoctor.value.phoneNo) = $event)),
        placeholder: "Telefon",
        iconClass: "pi pi-phone",
        validators: [_unref(FormValidator).isPresent, _unref(FormValidator).isValidPhone],
        validationMessage: "Numar de telefon invalid",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "email",
        modelValue: thisDoctor.value.email,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((thisDoctor.value.email) = $event)),
        placeholder: "Email",
        iconClass: "pi pi-envelope",
        validators: [_unref(FormValidator).isPresent, _unref(FormValidator).isValidEmail],
        validationMessage: "Adresa de email invalida",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CustomTextField, {
        id: "title",
        modelValue: thisDoctor.value.title,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((thisDoctor.value.title) = $event)),
        placeholder: "Titlu",
        iconClass: "pi pi-briefcase",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest camp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "specialization",
        modelValue: thisDoctor.value.specialization,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((thisDoctor.value.specialization) = $event)),
        placeholder: "Specializare",
        iconClass: "pi pi-file",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest camp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ])
  ]))
}
}

})